import { CustomTooltipColors } from '~/components/shared/componentStyles/CustomTooltip.colors'
import { createColorKeys } from '~/utils/chakraUtils'

import { AudioPlayerColors } from './AudioPlayer.colors'
import { BetaBadgeColors } from './BetaBadge.colors'
import { CheckboxColors } from './Checkbox.colors'
import { circleBadgeColors } from './CircleBadge.colors'
import { EmptyDetailViewColors } from './EmptyDetailView.colors'
import { EmptyStateColors } from './EmptyState.colors'
import { LoadingSpinnerColors } from './LoadingSpinner.colors'
import { MangoButtonColors } from './MangoButton.colors'
import { MenuColors } from './Menu.colors'
import { MenuItemColors } from './MenuItem.colors'
import { NewBadgeColors } from './NewBadge.colors'
import { NotificationBadgeColors } from './NotificationBadge.colors'
import { quickActionButtonColors } from './QuickActionButton.colors'
import { ScrollingInputDropdownColors } from './ScrollingInputDropdown.colors'
import { SearchInputColors } from './SearchInput.colors'
import { TabButtonColors } from './TabButton.colors'
import { TextButtonColors } from './TextButton.colors'

export const sharedComponentColors = {
  AudioPlayer: { ...AudioPlayerColors },
  BetaBadge: { ...BetaBadgeColors },
  Checkbox: { ...CheckboxColors },
  CircleBadge: { ...circleBadgeColors },
  EmptyDetailView: { ...EmptyDetailViewColors },
  EmptyState: { ...EmptyStateColors },
  LoadingSpinner: { ...LoadingSpinnerColors },
  MangoButton: { ...MangoButtonColors },
  NewBadge: { ...NewBadgeColors },
  NotificationBadge: { ...NotificationBadgeColors },
  QuickActionButton: { ...quickActionButtonColors },
  ScrollingInputDropdown: { ...ScrollingInputDropdownColors },
  SearchInput: { ...SearchInputColors },
  Menu: { ...MenuColors },
  MenuItem: { ...MenuItemColors },
  TabButton: { ...TabButtonColors },
  TextButton: { ...TextButtonColors },
  CustomTooltip: { ...CustomTooltipColors },
}

export const sharedComponentColorKeys = createColorKeys(sharedComponentColors)
